var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user)?_c('div',{staticClass:"d-block text-center fixed-top border-bottom border-light bg-dark text-light"},[_vm._v(" Kontostand: "+_vm._s(_vm._f("kies")(_vm.computedBalance))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }